import { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { m, AnimatePresence } from 'framer-motion';
// @mui
import { Dialog, Box, Paper, useTheme } from '@mui/material';
//
import { varFade, varZoom } from './variants';

import cssStyles from '../../utils/cssStyles';

// ----------------------------------------------------------------------

DialogAnimate.propTypes = {
  children: PropTypes.node.isRequired,
  onClose: PropTypes.func,
  open: PropTypes.bool.isRequired,
  sx: PropTypes.object,
  variants: PropTypes.object,
};

export default function DialogAnimate({ open = false, variants, onClose, children, sx, PaperProps, ...other }) {
  const theme = useTheme();

  return (
    <AnimatePresence>
      {open && (
        <Dialog
          fullWidth
          open={true}
          onClose={onClose}
          PaperComponent={m.div}
          PaperProps={{
            ...(variants ||
              varZoom({
                distance: 120,
                durationIn: 0.32,
                durationOut: 0.24,
                easeIn: 'easeInOut',
              }).in),
            ...PaperProps,
          }}
          BackdropProps={{ ...cssStyles(theme).bgBlur() }}
          {...other}
        >
          {children}
        </Dialog>
      )}
    </AnimatePresence>
  );
}
